import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class HeaderButtons extends Component {
    constructor(props) {
        super(props)
    }

    //BOTONES CABECERA
    render() {
        let permisos = this.props.permisos;
        let disabledNuevaEmpresaProp = { disabled: "disabled" };
        let disabledDisLimitesProp = { disabled: "disabled" };

        if (permisos.components.BotonNuevaEmpresa.Locked == false) {
            delete disabledNuevaEmpresaProp.disabled;
        }

        if (permisos.components.BotonDistribuirLimites.Locked == false) {
            delete disabledDisLimitesProp.disabled;
        }
        
        let cliente = this.props.tarjetas.clienteResultadoBusqueda;
        let limiteCliente = 0
        if(cliente && cliente.Id>0){
            limiteCliente = GlobalHelper.ObtenerLimitesEmpresaCliente(this.props.tarjetas.empresas, this.props.tarjetas.novedadesEmpresas, this.props.tarjetas.clienteResultadoBusqueda)
        }
        
        let empresaCreada = this.props.tarjetas.empresas.find(x => x.esNueva) !== undefined ? true : false;
        let esModificacion = this.props.tarjetas.esModificacion;

        return (
            <div>
                <div className="row">
                    {(permisos.components.BotonNuevaEmpresa.Active == true) &&
                        <div className="col-xs-2">
                            <Link to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_NUEVA_EMPRESA") + "/0"}
                                className={"btn btn-secondary " + ((empresaCreada || esModificacion) ? "disabled" : "")} >Nueva Empresa</Link>
                        </div>}

                    {(permisos.components.BotonDistribuirLimites.Active == true && cliente.Id>0) &&
                        <div className="col-xs-2">
                            <button className="btn btn-secondary" type="submit" onClick={(event) => this.goToLimits(event)}
                                {...disabledDisLimitesProp}>
                                Distribuir límites
                            </button>
                        </div>}

                    {(permisos.components.BotonDistribuirLimites.Active == true && limiteCliente.LimiteSinAsignar < 0) &&
                        <div className="col-xs-1">
                            <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }} />
                        </div>}


                </div>
                <GenericModal
                    type={"WARNING"}
                    className="modal fade-out"
                    id={"warning_borrar_futuro_from_empresa"}
                    header={"Advertencia"}
                    body={"Por favor, tenga en cuenta que si genera una nueva empresa perderá el progreso realizado hasta el momento."}
                />
            </div>
        );
    }

    goToLimits() {
        this.props.openModalDistribucionLimites();
    }

    goToNewEnterprise() {
        NuevaSolicitudEmpresaActions.RouteToNewEnterprise();
    }
}

export default HeaderButtons